import React from "react";
import { connect } from "react-redux";
import { withStyles } from "@material-ui/styles";
import { withRouter } from "react-router-dom";
import { get} from "lodash";
import { InputAdornment, TextField } from "@material-ui/core";
import Close from "@material-ui/icons/Close";

const styles = {
    searchInput: {
    width: "130px",
    height: "36px",
    marginBottom: "16px",
    fontSize: "14px",

    "& .MuiOutlinedInput-input": {
      padding: "14px 8px 14px 0px",
    },

    "&::placeholder": {
        fontStyle: "italic",
        },
    '@media(max-width: 470px)' : {
        width: "290px",
        }
    },

    resultsHeader:{
        display: "flex"
    },

    resultRow : {
        display: "flex",
        width: "250px"
    },

    poCode: {
        width: "120px",
        height: "36px",
        color: "rgba(0,0,0,0.54)",
        display: "flex",
        alignItems: "center",
    }

};



const POReplacementRow = (props) => {
  const { handlePoReplace, data, classes } = props;

  const [poCode, setPoCode] = React.useState("")

  const handleSetPoCode = value => {
    value.length <= 35 ? setPoCode(value) : setPoCode(value.substring(0,35)) 
      
      // 123456789012345678901234567890123456

  }

  return (
    <div className={classes.resultRow}>
        <div className={classes.poCode}>{data}</div>
        <TextField
            value={poCode}
            onChange={e => {handleSetPoCode(e.target.value); handlePoReplace({old_value: data, new_value: e.target.value})}}
            
            variant="outlined"
            InputProps={{
                endAdornment: poCode ? <InputAdornment position="start" style={{ color: "rgba(0, 0, 0, 0.38)", cursor: "pointer" }} onClick={e => {setPoCode(""); handlePoReplace({old_value: data, new_value: ""})}}><Close /></InputAdornment> : null,
                className: classes.searchInput,
                style: {fontSize: 14, padding: "0 0 0 8px"}
            }}
        />
    </div>
  )
}

const mapStateToProps = (state) => {
  return {
    language: get(state, ["user", "language"]),
  };
};

export default withRouter(
  connect(mapStateToProps)(withStyles(styles)(POReplacementRow))

);